// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"442":"47532aac","453":"ae8c579a","987":"8fe550b0"}[chunkId] + ".chunk.js";
};